module.exports = __webpack_public_path__ + "img/et.627e47e6.png";